import { AfterViewInit, Directive, HostListener, OnDestroy } from '@angular/core';
import { ProcessEventFactory } from '@shared/models/processEvents';
import { ProcessEventService } from '@shared/services/process-event.service';
import { assert } from 'ts-essentials';

@Directive({
  selector: '[appDomChange]',
})
export class DomChangeDirective implements AfterViewInit, OnDestroy {
  private changes: MutationObserver;

  constructor(private processEventService: ProcessEventService) {
    this.changes = new MutationObserver((mutations: MutationRecord[]) => {
      mutations.forEach((_mutation: MutationRecord) => {
        this.onDomChange();
      });
    });
  }

  ngAfterViewInit(): void {
    this.changes.observe(document.body, { childList: true, subtree: true });
  }

  ngOnDestroy(): void {
    this.changes.disconnect();
  }

  @HostListener('window:resize')
  onResize() {
    this.onDomChange();
  }

  @HostListener('window:load')
  onLoad() {
    this.onDomChange();
  }

  private onDomChange(): void {
    const html = document.getElementsByTagName('html')[0];
    assert(html != null);
    const w = html.offsetWidth;
    const h = html.offsetHeight;
    this.processEventService.push(ProcessEventFactory.SpawnWindowResizeEvent(w + '|' + h));
  }
}
